import { createMedia } from "@tamagui/react-native-media-driver";

// Tamagui's stock widths. Order matters: a later key beats an earlier one when
// both match, so the max-width keys run widest → narrowest ($xs wins over $sm
// on a phone). Only web-admin uses anything but `xs`; web-hub is a fixed
// 1920x480 kiosk and never matches the max-width keys.
export const mediaQueries = createMedia({
  lg: { maxWidth: 1280 },
  md: { maxWidth: 1020 },
  sm: { maxWidth: 800 },
  xs: { maxWidth: 660 },
  gtXs: { minWidth: 661 },
  gtSm: { minWidth: 801 },
  gtMd: { minWidth: 1021 },
  gtLg: { minWidth: 1281 },
});
